import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class PiBuilderService {
    list = [];
    filters = [];

    constructor() {
       // this.add(this.directory())
       //     .add(this.defaultOther(""))
       //     .sort();
    }

    public reset() {
        this.list = [];
        this.filters = [];

        return this;
    }

    public filter(filter) {
        this.filters.push(filter);

        return this;
    }

    public add(entry) {
        if (!entry) {
            return this;
        }

        if (Array.isArray(entry)) {
            this.list = this.list.concat(entry);
        }
        else {
            this.list = this.list.concat([entry]);
        }

        //remove duplicates
        this.list = this.list.filter((obj1, i, arr) =>
            arr.findIndex(obj2 => (obj2.Name === obj1.Name)) === i
        )

        return this;
    }

    public remove(entry) {
        if (Array.isArray(entry)) {
            entry.forEach(i => {
                this.remove(i);
            });
        }
        else {
            const search = entry && entry.Name ? entry.Name : entry;

            this.list = this.list.filter(i => i.Name !== search);
        }

        return this;
    }

    public sort() {
        this.list.sort((a, b) => {
            if (a.Name === "GLOBAL.OTHER") {
                return 1;
            }
            if (a.Name < b.Name) {
                return -1;
            }
            if (a.Name > b.Name) {
                return 1;
            }
            return 0;
        });

        return this;
    }

    public build(list) {
        let includes = [];
        let excludes = [];

        this.filters.forEach(filter => {
            filter.start(list).filter();
            includes = includes.concat(filter.include());
            excludes = excludes.concat(filter.exclude());
        });

        this.remove(excludes);
        this.add(includes);

        return this;
    }

    public getList() {
        return Array.from(this.list);
    }

    public getNames(): any[] {
        return Array.from(this.list.map(entry => {
            return entry.Name;
        }));
    }

    public getPiByName(piName) {
        if (piName.toLowerCase() === "other" || piName.toLowerCase() === "otra" || piName.toLowerCase() === "其他") {
            piName = "GLOBAL.OTHER";
        }

        const result = this.list.filter(i => {
            return i.Name.toLowerCase() === piName.toLowerCase() || i.Name.toLowerCase() === piName.toLowerCase() + "-2016";
        });

        if (Array.isArray(result)) {
            return result[0];
        }
    };

    public defaultOther(defaultUrl: string) {
        return {
            Name: "GLOBAL.OTHER",
            // tslint:disable-next-line:max-line-length
            Url: defaultUrl ? defaultUrl : "https://www.earthquakeauthority.com/California-Earthquake-Insurance-Policies/Participating-Residential-Insurers-Earthquake",
            Active: "1/1/2016",
            Deactive: ""
        };
    }

    public directory() {
        return [
            {
                Name: "ACA Insurance (AAA)",
                Url: "https://calstate.aaa.com/about-aaa/contact-us/find-agent-branch",
                Active: "1/1/2016",
                Deactive: "1/1/2019"
            },
            {
                Name: "Allstate",
                Url: "https://agents.allstate.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Amica Mutual Insurance Company",
                Url: "https://www.amica.com/en.html",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Armed Forces Insurance Exchange",
                Url: "https://www.afi.org/",
                Active: "1/1/2016",
                Deactive: "7/1/2025"
            },
            {
                Name: "ASI-2016",
                Url: "https://www.americanstrategic.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Automobile Club of Southern California (AAA)",
                Url: "https://www.calif.aaa.com",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "CSAA-AAA Northern California",
                Url: "https://calstate.aaa.com/about-aaa/contact-us/find-agent-branch",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "California FAIR Plan",
                Url: "https://www.cfpnet.com/index.php/find-a-broker/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Commerce West",
                Url: "https://www.mapfreinsurance.com/b2cwebapp/cwic/home",
                Active: "1/1/2016",
                Deactive: "1/1/2019"
            },
            {
                Name: "Encompass",
                Url: "https://www.encompassinsurance.com/agency-locator.aspx",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Farmers Insurance Group",
                Url: "https://agents.farmers.com/search.html",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Foremost",
                Url: "https://www.foremost.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Hyundai",
                Url: "http://www.hyundaiinsuranceusa.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Liberty Mutual Group Business Insurance",
                Url: "https://www.libertymutualgroup.com",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Liberty Mutual Insurance",
                Url: "https://www.libertymutual.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "MAPFRE",
                Url: "https://www.mapfreinsurance.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Mercury",
                Url: "https://www.mercuryinsurance.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "NatGen Premier",
                Url: "https://www.natgenpremier.com/",
                Active: "8/4/2025",
                Deactive: ""
            },
            {
                Name: "Nationwide Insurance",
                Url: "https://agency.nationwide.com/ca",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Nationwide Private Client",
                Url: "https://www.nationwideprivateclient.com/find-an-agent",
                Active: "1/1/2016",
                Deactive: "11/17/2025"
            },
            {
                Name: "Progressive-2016",
                Url: "https://www.progressive.com/agent/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Safeco",
                Url: "https://www.safeco.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "State Farm Insurance",
                Url: "https://www.statefarm.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Toggle",
                Url: "https://www.gettoggle.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "USAA",
                Url: "https://www.usaa.com/",
                Active: "1/1/2016",
                Deactive: ""
            },
            {
                Name: "Wawanesa",
                Url: "https://www.wawanesa.com/us/support/contact-us.html",
                Active: "7/1/2025",
                Deactive: ""
            }
        ];
    }
}
